import React from 'react';
import { createRoot } from 'react-dom/client';

import './setupMatchMedia'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// redux stuff
import { Provider } from 'react-redux'
import store from './redux/store'

// Amplify Stuff
import Amplify from 'aws-amplify'
import awsmobile from './awsmobile'
Amplify.configure(awsmobile)


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <Router>
      <Route component={App} />
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
